import { useDispatch, useSelector } from "react-redux"

import useFetch from "../../../hook/useFetch"
import { Fragment, useEffect, useState } from "react"
import { userActions } from "../../../store/user-slice"
import { notificationActions } from "../../../store/notification-slice"
import useIsMobile from '../../../hook/useIsMobile';

import DesktopComponent from "./datatable/DesktopComponent"
import MobileComponent from './datatable/MobileComponent';
import { useLocation, useNavigate, useParams } from "react-router-dom"
import EditUser from "./EditUser"
import useFilter from "../../../hook/useFilter"
import Skeleton from "react-loading-skeleton"

export default function Users() {


    const { get } = useFetch()
    
    const [users, setUsers] = useState()
    let dispatch = useDispatch()

    let location = useLocation()


    const { convertToArray } = useFilter()

    const { id } = useParams();


    const fetchUsers = () => {
        setUsers(null)
        dispatch(userActions.resetUsers())
       
        get('/admin/users', null, (data) => {
            dispatch(notificationActions.setNotification({
                message: data,
                status: false
            }))
        }, (data) => {
            data = convertToArray(data)
            setUsers(data)
            dispatch(userActions.setUsers(data))

        })
    }

    useEffect(() => {

        fetchUsers()


    }, [])


    useEffect(() => {
        
        if (location.state && location.state.refetch) {
            
            fetchUsers()

        }
    }, [location.state])

    if (!users) {
        return <Skeleton count={50} />
    }

    if (id) {

        return <EditUser id={id} />
    }



    return <Fragment>{users && <Datatable users={users} />}</Fragment>
}


const Datatable = () => {


    const { isMobile } = useIsMobile()
    const navigate = useNavigate()
    const [selected, setSelected] = useState([])
    const select = (id, checked) => setSelected(previous => checked
        ? [...new Set([...previous, Number(id)])]
        : previous.filter(value => value !== Number(id)))
    const compose = ids => navigate('/admin/mail', { state: { userIds: ids } })

    return <div className="rso-pages card shadow bg-white rounded p-3 m-0">
        <div className="d-flex align-items-center flex-wrap gap-2 mb-3">
            <button className="btn btn-primary" type="button" disabled={selected.length === 0 || selected.length > 50}
                onClick={() => compose(selected)}>E-Mail an {selected.length} ausgewählte Nutzer verfassen</button>
            <span className="text-muted small">Maximal 50 Empfänger pro Versand.</span>
        </div>
        {isMobile
            ? <MobileComponent selected={selected} onSelect={select} onCompose={compose} />
            : <DesktopComponent selected={selected} onSelect={select} onCompose={compose} />}
    </div>

}



